import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as ContentActions from './content.actions';
import { ContentDto } from '@api/rest';

export const contentsFeatureKey = 'contents';

export interface State extends EntityState<ContentDto> {
  selected: string;
}

export const adapter: EntityAdapter<ContentDto> = createEntityAdapter<ContentDto>({
  selectId: content => content._id
});

export const initialState: State = adapter.getInitialState({
  selected: undefined
});


export const reducer = createReducer(
  initialState,
  on(ContentActions.loadContentsSuccess, (state, action) =>
    adapter.setAll(action.contents, state)
  ),
  on(ContentActions.getContentSuccess, (state, action) =>
    adapter.upsertOne(action.content, state)
  ),
  on(ContentActions.setSelectedContent, (state, action) =>
    ({ ...state, selected: action.id })
  )
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
